var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('rental-schedule-view', {
    on: {
      "save": _vm.save
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }, {
      key: "loader",
      fn: function fn() {
        return [_c('v-fade-transition', [_c('v-overlay', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }],
          attrs: {
            "absolute": "",
            "light": "",
            "color": "white"
          }
        }, [_c('v-col', {
          staticClass: "text-center"
        }, [_c('v-progress-circular', {
          staticClass: "ma-4",
          attrs: {
            "size": "100",
            "width": "5",
            "color": "black",
            "indeterminate": ""
          }
        }), _vm._v(" "), _c('br'), _c('span', {
          staticClass: "black--text caption"
        }, [_vm._v(" 요청을 취합하고 있습니다. ")])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, true)
  });
}
var staticRenderFns = []

export { render, staticRenderFns }